(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-benefits-tabs"] && !Shopify.designMode) return;
  try {
        
  window.addEventListener('DOMContentLoaded', () => {
    const tabs = document.querySelectorAll('[role="tab"]');
    const tabList = document.querySelector('[role="tablist"]');

    tabs.forEach(tab => {
      tab.addEventListener('click', e => {
        const parent = e.target.parentNode;
        const targetPanel = e.target.getAttribute('aria-controls');

        // Remove all current states
        parent.querySelectorAll('[aria-selected="true"]').forEach(t => t.setAttribute('aria-selected', false));
        parent.querySelectorAll('[tabindex="0"]').forEach(t => t.setAttribute('tabindex', -1));
        
        // Hide all panels
        const container = parent.parentNode;
        container.querySelectorAll('[role="tabpanel"]').forEach(p => p.setAttribute('hidden', true));

        // Set active state
        e.target.setAttribute('aria-selected', true);
        e.target.setAttribute('tabindex', 0);
        container.querySelector(`#${targetPanel}`).removeAttribute('hidden');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-ingredients"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const accordionItems = document.querySelectorAll('.ingredient__accordion');

    let activeAccordion = null;

    accordionItems.forEach((item) => {
      const content = item.querySelector(
        '.ingredient_accordion__content'
      );
      const button = item.querySelector(
        '.ingredient_accordion__header'
      );

      button.addEventListener('click', function () {
        const isExpanded = button.getAttribute('aria-expanded') === 'true';

        // 1. Close all other accordions (Single-open behavior)
        accordionItems.forEach((otherItem) => {
          if (otherItem !== item) {
            const otherButton = otherItem.querySelector('.ingredient_accordion__header');
            const otherContent = otherItem.querySelector('.ingredient_accordion__content');
            
            otherButton.setAttribute('aria-expanded', 'false');
            otherContent.style.height = '0px';
          }
        });

        // 2. Toggle current accordion
        if (isExpanded) {
          button.setAttribute('aria-expanded', 'false');
          content.style.height = '0px';
        } else {
          button.setAttribute('aria-expanded', 'true');
          content.style.height = content.scrollHeight + 'px';
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
